﻿import {PagerOptions} from "./Pager";

export const DEFAULT_OPTIONS: PagerOptions = {
	ariaLabels: {
		current: "page #",
		first: "Go to first page",
		last: "Go to last page",
		next: "Go to next page",
		previous: "Go to previous page",
		target: "Go to page #"
	},
	boundaryCount: 1,
	siblingCount: 1
};
